export const INDUSTRY_STORE = 'INDUSTRY_STORE';
export const INDUSTRY_UPDATE = 'INDUSTRY_UPDATE';
export const INDUSTRY_DESTROY = 'INDUSTRY_DESTROY';
